//-----------------------
// React basic Components
//-----------------------
  import React                                               from "react";
//import PropTypes                                           from "prop-types";
//import { makeStyles }                                      from '@material-ui/core/styles';
  import { GoogleApiWrapper, InfoWindow, Map, Marker }       from 'google-maps-react';

  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";

  import { container }                                       from "assets/jss/material-dashboard-pro-react.jsx";

//import logo_wu                                             from "assets/img/wu/maps/logo-wu.png";
//import logo_gc                                             from "assets/img/wu/maps/logo-gocash.png";
  import logo_wu_SVG                                         from "assets/img/wu/maps/logo-wu.svg";
//import logo_gc_SVG                                         from "assets/img/wu/maps/logo-gocash.svg";
  import logo_gc_SVG                                         from "assets/img/wu/maps/bill_payment.svg";

//import Button                                              from '@material-ui/core/Button';
  import DirectionsIcon                                      from '@material-ui/icons/Directions';

  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { api }                                             from "../../_constants";
//----------
// variables
//----------
const filename = "GoogleMapsContainer ";
const print_logs = true;

class GoogleMapsContainer extends React.Component {

constructor(props) {
  super(props);

  // binding this to event-handler functions
  this.onMarkerClick       = this.onMarkerClick.bind(this);
  this.onMyMarkerClic      = this.onMyMarkerClick.bind(this);
  this.displayMarkers      = this.displayMarkers.bind(this);
  this.displayMyMarker     = this.displayMyMarker.bind(this);
  this.onMapClick          = this.onMapClick.bind(this);
  this.onInfoWindowClose   = this.onInfoWindowClose.bind(this);

  this.onIdle              = this.onIdle.bind(this);
  this.onTilesloaded       = this.onTilesloaded.bind(this);
  this.onZoomChanged       = this.onZoomChanged.bind(this);

  this.state = {
    autoCompleteSearchEnabled                  : api.autoCompleteSearchEnabled, //newSearchEnabled

    isMyLocation                               : false,
    showingInfoWindow                          : false,
    infoWindow_lat                             : 37.9615514,
    infoWindow_lon                             : 23.7333268,
    infoWindow_loc_name                        : "",
    infoWindow_addr                            : "",
    infoWindow_timetable_key                   : "",
    infoWindow_timetable_val                   : "",
    infoWindow_isOpen                          : false,
    infoWindow_tel                             : "",
    infoWindow_services                        : "",
    infoWindow_show_WU_image                   : false,
    infoWindow_show_GC_image                   : false,
    activeMarker                               : {},
    selectedPlace                              : {},
    searchResults                              : [],
    initialized                                : false,
  }
  //------------
  //translations
  //------------
  this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
  this.texts_en = wu_StaticDataService.wu_getLocales_en({});
}
//----------------------------------------------------------------------------------------------------
componentWillMount() {
  let methName = filename+"componentWillMount ";
  if(api.print_logs){console.log(methName);}
  document.body.style.overflow = 'hidden';
}
//----------------------------------------------------------------------------------------------------
componentDidMount() {
  //let methName = filename+"componentDidMount ";
  //if(api.print_logs){console.log(methName);}
}
//----------------------------------------------------------------------------------------------------
componentWillUnmount() {
  let methName = filename+"componentWillUnmount ";
  if(api.print_logs){console.log(methName);}
  document.body.style.overflow = 'unset';
}
//----------------------------------------------------------------------------------------------------
render() {
  let methName = filename+"render ";
  if(api.print_logs){console.log(methName);}

  //const classes = useStyles();
  //let onMarkerClick     = this.onMarkerClick;

//let maxWidth = localStorage.getItem("mobileOpen")==="true" ? 250     : 300;
//let style_w  = localStorage.getItem("mobileOpen")==="true" ? '310px' : '600px';
//let style_h  = localStorage.getItem("mobileOpen")==="true" ? '500px' : '500px';
  let maxWidth = window && window.innerWidth >= 960 ? 300     : 250;
  let style_w  = window && window.innerWidth >= 960 ? '600px' : '310px';
  let style_h  = window && window.innerWidth >= 960 ? '410px' : '410px';
  if(api.print_logs){console.log(methName+'style_w,style_h                = '+style_w+' '+style_h);}
  if(api.print_logs){console.log(methName+'window.innerWidth,innerHeight  = '+window.innerWidth+' '+window.innerHeight);}

  const style = {
// width         : '50vw',
// height        : '75vh',
// 'marginLeft'  : 'auto',
// 'marginRight' : 'auto'
    width        : style_w,
    height       : style_h,
  //height       : '100',
    'margin'     : '0px',
    'padding'    : '0px',
    overflow     : 'hidden',
  };

  var showMap = true;
  if(!this.props)                                        {showMap=false; console.log(methName+'01');}
  if(!this.props.google)                                 {showMap=false; console.log(methName+'02');}
  if(!this.props.google.maps)                            {showMap=false; console.log(methName+'03');}
  if(!this.props.initialZoom)                            {showMap=false; console.log(methName+'04');}  try{console.log(methName+'!this.props.initialZoom                             = '+this.props.initialZoom);                             } catch(err){;}
  if(!this.props.google.maps.ControlPosition)            {showMap=false; console.log(methName+'05');}  try{console.log(methName+'!this.props.google.maps.ControlPosition             = '+this.props.google.maps.ControlPosition);             } catch(err){;}
  if(!this.props.google.maps.ControlPosition.LEFT_BOTTOM){showMap=false; console.log(methName+'06');}  try{console.log(methName+'!this.props.google.maps.ControlPosition.LEFT_BOTTOM = '+this.props.google.maps.ControlPosition.LEFT_BOTTOM); } catch(err){;}
  if(!this.props.initialCenterLat)                       {showMap=false; console.log(methName+'07');}  try{console.log(methName+'!this.props.initialCenterLat                        = '+this.props.initialCenterLat);                        } catch(err){;}
  if(!this.props.initialCenterLon)                       {showMap=false; console.log(methName+'08');}  try{console.log(methName+'!this.props.initialCenterLon                        = '+this.props.initialCenterLon);                        } catch(err){;}
  if(!this.props.searchResults)                          {showMap=false; console.log(methName+'09');}  try{console.log(methName+'!this.props.searchResults                           = '+this.props.searchResults);                           } catch(err){;}
/*if(!this.props.showingInfoWindow)                      {showMap=false; console.log(methName+'10');}*/try{console.log(methName+'!this.props.showingInfoWindow                       = '+this.props.showingInfoWindow);                       } catch(err){;}

/*if(!this.state.infoWindow_lat)                         {showMap=false; console.log(methName+'11');}*/try{console.log(methName+'!this.state.infoWindow_lat                          = '+this.state.infoWindow_lat);                          } catch(err){;}
/*if(!this.state.infoWindow_lon)                         {showMap=false; console.log(methName+'12');}*/try{console.log(methName+'!this.state.infoWindow_lon                          = '+this.state.infoWindow_lon);                          } catch(err){;}
/*if(!this.state.infoWindow_loc_name)                    {showMap=false; console.log(methName+'13');}*/try{console.log(methName+'!this.state.infoWindow_loc_name                     = '+this.state.infoWindow_loc_name);                     } catch(err){;}
/*if(!this.state.isMyLocation)                           {showMap=false; console.log(methName+'14');}*/try{console.log(methName+'!this.state.isMyLocation                            = '+this.state.isMyLocation);                            } catch(err){;}
/*if(!this.state.autoCompleteSearchEnabled)              {showMap=false; console.log(methName+'15');}*/try{console.log(methName+'!this.state.autoCompleteSearchEnabled               = '+this.state.autoCompleteSearchEnabled);               } catch(err){;}
/*if(!this.state.infoWindow_addr)                        {showMap=false; console.log(methName+'16');}*/try{console.log(methName+'!this.state.infoWindow_addr                         = '+this.state.infoWindow_addr);                         } catch(err){;}
/*if(!this.state.infoWindow_timetable_key)               {showMap=false; console.log(methName+'17');}*/try{console.log(methName+'!this.state.infoWindow_timetable_key                = '+this.state.infoWindow_timetable_key);                } catch(err){;}
/*if(!this.state.infoWindow_timetable_val)               {showMap=false; console.log(methName+'18');}*/try{console.log(methName+'!this.state.infoWindow_timetable_val                = '+this.state.infoWindow_timetable_val);                } catch(err){;}
/*if(!this.infoWindow_isOpen)                            {showMap=false; console.log(methName+'19');}*/try{console.log(methName+'!this.state.infoWindow_isOpen                       = '+this.state.infoWindow_isOpen);                       } catch(err){;}
/*if(!this.state.infoWindow_tel_key)                     {showMap=false; console.log(methName+'20');}*/try{console.log(methName+'!this.state.infoWindow_tel_key                      = '+this.state.infoWindow_tel_key);                      } catch(err){;}
/*if(!this.state.infoWindow_tel_val)                     {showMap=false; console.log(methName+'21');}*/try{console.log(methName+'!this.state.infoWindow_tel_val                      = '+this.state.infoWindow_tel_val);                      } catch(err){;}
/*if(!this.state.infoWindow_services)                    {showMap=false; console.log(methName+'22');}*/try{console.log(methName+'!this.state.infoWindow_services                     = '+this.state.infoWindow_services);                     } catch(err){;}
/*if(!this.state.infoWindow_show_WU_image)               {showMap=false; console.log(methName+'23');}*/try{console.log(methName+'!this.state.infoWindow_show_WU_image                = '+this.state.infoWindow_show_WU_image);                } catch(err){;}
/*if(!this.state.infoWindow_show_GC_image)               {showMap=false; console.log(methName+'24');}*/try{console.log(methName+'!this.state.infoWindow_show_GC_image                = '+this.state.infoWindow_show_GC_image);                } catch(err){;}
  if(showMap===false){
    return ("");
  }
  try{
  return (
    <div id="GoogleMapsContainer_div01" className={container}>
      <GridContainer>
        <GridItem>
          <Map
            item
            style                = { style }
            google               = { this.props.google }
            onClick              = { this.onMapClick }
            zoom                 = { this.props.initialZoom }
            zoomControl          = { true }
            zoomControlOptions   = { this.props.google.maps.ControlPosition.LEFT_BOTTOM }
          //initialCenter        = {{ lat:this.props.initialCenterLat, lng:this.props.initialCenterLon }}
            center               = {{ lat:this.props.initialCenterLat, lng:this.props.initialCenterLon }}
            onReady              = { this.onReady }
            onDragend            = { this.onDragend }
            onRecenter           = { this.onRecenter }
            onBounds_changed     = { this.onBounds_changed }
            onCenter_changed     = { this.onCenter_changed }
            onDblclick           = { this.onDblclick }
            onDragstart          = { this.onDragstart }
            onHeading_change     = { this.onHeading_change }
            onIdle               = { this.onIdle }
            onMaptypeid_changed  = { this.onMaptypeid_changed }
            // onMousemove          = { this.onMousemove }
            // onMouseout           = { this.onMouseout }
            // onMouseover          = { this.onMouseover }
            onProjection_changed = { this.onProjection_changed }
            onResize             = { this.onResize }
            onRightclick         = { this.onRightclick }
            onTilesloaded        = { this.onTilesloaded }
            onTilt_changed       = { this.onTilt_changed }
            onZoom_changed       = { this.onZoom_changed }
            onZoomChanged        = { this.onZoomChanged }
          >
          {this.displayMyMarker()}
          {this.displayMarkers(this.props.searchResults)}
          <InfoWindow
            visible={this.props.showingInfoWindow}
          //visible={this.state.showingInfoWindow}
            position={{lat: this.state.infoWindow_lat,lng: this.state.infoWindow_lon}}
            onClose={()=>{this.onInfoWindowClose()}}
            options={{maxWidth: maxWidth}}
          >
            <div style={{overflow:"hidden"}}>
              <div style={{fontFamily:'"Helvetica"', fontWeight:"300", color:"#35B6B4"}}>{this.state.infoWindow_loc_name}</div><br/>

              {this.state.isMyLocation === false ? (
              <React.Fragment>
                <div style={{fontFamily:'"Helvetica"', fontWeight:"300",  color:"#1A1A1A", display:"flex","align-items":"center" }}>
                  {this.state.autoCompleteSearchEnabled === true ? (
                    <React.Fragment><a target="_blank" rel="noopener noreferrer" href={'http://maps.google.com/maps?q=loc:'+this.state.infoWindow_lat+','+this.state.infoWindow_lon+'&navigate=yes'}><DirectionsIcon fontSize="large" style={{ color:"#000000", padding:0, margin: 0 }}/></a><span style={{"vertical-align":"top"}}>{this.state.infoWindow_addr}</span></React.Fragment>
                  ) : (
                    <span style={{"vertical-align":"top"}}>{this.state.infoWindow_addr}</span>
                  )}
                </div><br/>
                <div style={{fontFamily:'"Helvetica"', fontWeight:"300",  color:"#1A1A1A", marginTop:0}}><b>{this.state.infoWindow_timetable_key}</b> {this.state.infoWindow_timetable_val} - <span style={{color:this.state.infoWindow_isOpen?"green":"red"}}>{this.state.infoWindow_isOpen===true? this.NSInforString("StoreLocator_lbl_open"):this.NSInforString("StoreLocator_lbl_closed")}</span></div>
                <div style={{fontFamily:'"Helvetica"', fontWeight:"300",  color:"#1A1A1A", marginTop:5 }}><b>{this.state.infoWindow_tel_key}</b><a href={"tel://"+this.state.infoWindow_tel_val}>{this.state.infoWindow_tel_val}</a></div>
                <div style={{fontFamily:'"Helvetica"', fontWeight:"300",  color:"#1A1A1A", marginTop:5}}><b>{this.state.infoWindow_services}</b></div>
                <div style={{fontFamily:'"Helvetica"', fontWeight:"300",  color:"#1A1A1A", marginTop:5}}>
                  {this.state.infoWindow_show_WU_image===false ? ("") : <div style={{display:"inline-block", "verticalAlign":"top"}}><img src={logo_wu_SVG} width="114" height="37" alt=""/><span style={{"textAlign":"center", fontSize:"0.65rem",display:"block"}}>Western Union</span></div> }
                  &nbsp;
                  {this.state.infoWindow_show_GC_image===false ? ("") : <div style={{display:"inline-block", "verticalAlign":"top"}}><img src={logo_gc_SVG} width="144" height="37" alt=""/><span style={{"textAlign":"center", fontSize:"0.65rem",display:"block"}}>{this.NSInforString("StoreLocator_bill_payment_text")}</span></div> }<br/>
                </div>
              </React.Fragment>) : ( "")}
            </div>
          </InfoWindow>
          </Map>
        </GridItem>
      </GridContainer>
    </div>
  );
  } catch(err){
    return ("");
  }
}
//----------------------------------------------------------------------------------------------------
displayMarkers (stores) {
  return stores.map((aItem, index) => {
   return <Marker
     key      = { aItem.loc_id }
     onClick  = { (event) => this.onMarkerClick(aItem,this.props) }
     title    = { aItem.loc_name }
     position = {{ lat: aItem.gm_latitude, lng: aItem.gm_longitude }}
     name     = { aItem.loc_name }
   >
   </Marker>
  })
}
//----------------------------------------------------------------------------------------------------
displayMyMarker () {
  //https://stackoverflow.com/questions/8248077/google-maps-v3-standard-icon-shadow-names-equiv-of-g-default-icon-in-v2
  let lat1 = localStorage.getItem("gpslat");
  let lon1 = localStorage.getItem("gpslon");
  if(lat1===null || (typeof lat1 === "undefined") || lat1==="" || lon1===null || (typeof lon1 === "undefined") || lon1===""){
    return;
  }
   return <Marker
     key      = { "00000000000000000000000000000000" }
     onClick  = { (event) => this.onMyMarkerClick(this.props) }
     title    = { (localStorage.getItem("lang")==="en") ? "My Location" : "Η τοποθεσία μου"}
     position = {{ lat: lat1, lng: lon1 }}
     name     = { (localStorage.getItem("lang")==="en") ? "My Location" : "Η τοποθεσία μου"}
     icon     = { "https://maps.gstatic.com/mapfiles/ms2/micons/blue-dot.png" }
   >
   </Marker>
}
//----------------------------------------------------------------------------------------------------
onMarkerClick(aItem,aProps){
  if(api.print_logs){console.log('aItem='+JSON.stringify(aItem));}
  //{"loc_id":4581,"loc_name":"AB MEGARA","sa_name":"AB VASILOPOULOS","prefecture_name_en":"Attica","prefecture_name_el":"Αττικής","sub_prefecture_name_en":"West Attica","sub_prefecture_name_el":"Δυτικής Αττικής","municipal_name_en":"Megara","municipal_name_el":"Μεγάρων","locale_name_en":"Megara","locale_name_el":"Μέγαρα","addr_en":"371 O.T. EPI TIS ODOU MEGARON ALEPOCHORIOU","addr_el":"371 Ο.Τ. ΕΠΙ ΤΗΣ ΟΔΟΥ ΜΕΓΑΡΩΝ ΑΛΕΠΟΧΩΡΙΟΥ","city_en":"Ymittos","city_el":"Υμηττός","post_code":"19100","tel":"2296027581","fax":"2296080274","email":null,"is_headqrt":0,"is_seasonal":0,"dma_pricing":1,"zone_name_en":"Dytiki Attiki","zone_name_el":"Δυτική Αττική","subzone_name_en":"MEGARA","subzone_name_el":"ΜΕΓΑΡΑ","sa_loc_status":null,"gm_latitude":38.055619,"gm_longitude":23.277958,"gm_address":null,"gm_zoom":0,"timetableEN":"Mon-Fri: 08:30 - 20:30, Sat: 09:00 - 19:30","timetableEL":"Δευ-Παρ: 08:30 - 20:30, Σαβ: 09:00 - 19:30","loc_Services":"WU","InfoWindowVisible":false}
  for(let i=0; i<this.props.searchResults.length; ++i){
    if(this.props.searchResults[i].loc_id===aItem.loc_id){
      this.props.searchResults[i]["InfoWindowVisible"]=true;
      //console.log('this.props.searchResultsp[i].loc_id='+this.props.searchResults[i].loc_id);
      this.setState({
        isMyLocation             : false,
        searchResults            : this.props.searchResults,
        showingInfoWindow        : true,
        infoWindow_loc_name      : aItem.loc_name,
        infoWindow_addr          : (localStorage.getItem("lang")==="en") ? aItem.addr_en+" "+this.get_localename_FromObj(aItem)+" "+this.get_postcode_FromObj(aItem) : aItem.addr_el+" "+this.get_localename_FromObj(aItem)+" "+this.get_postcode_FromObj(aItem),
        infoWindow_timetable_key : (localStorage.getItem("lang")==="en") ? "Timetable: "                   : "Ώρες Λειτουργίας: ",
        infoWindow_timetable_val : (localStorage.getItem("lang")==="en") ? aItem.timetableEN               : aItem.timetableEL,
        infoWindow_isOpen        : this.get_isOpenNow_FromObj(aItem),
        infoWindow_tel           : (localStorage.getItem("lang")==="en") ? "Phone Number: "+aItem.tel      : "Τηλέφωνο: "+aItem.tel,
        infoWindow_tel_key       : (localStorage.getItem("lang")==="en") ? "Phone Number: "                : "Τηλέφωνο: ",
        infoWindow_tel_val       : (localStorage.getItem("lang")==="en") ? aItem.tel                       : aItem.tel,
        infoWindow_services      : (localStorage.getItem("lang")==="en") ? "Available Services: "          : "Διαθέσιμες Υπηρεσίες: ",
        infoWindow_show_WU_image : this.show_WU_image(aItem),
        infoWindow_show_GC_image : this.show_GC_image(aItem),
        infoWindow_lat           : aItem.gm_latitude,
        infoWindow_lon           : aItem.gm_longitude,
      });
      aProps.updateParentInitialLatLon(aItem.gm_latitude,aItem.gm_longitude);//sos//
      aProps.update_showingInfoWindow(true);
    }
  }
}
//----------------------------------------------------------------------------------------------------
onMyMarkerClick(aProps){

  let lat1 = localStorage.getItem("gpslat");
  let lon1 = localStorage.getItem("gpslon");
  if(lat1===null || (typeof lat1 === "undefined") || lat1==="" || lon1===null || (typeof lon1 === "undefined") || lon1===""){

  }
  else{
    this.setState({
      isMyLocation             : true,
      searchResults            : this.props.searchResults,
      showingInfoWindow        : true,
      infoWindow_loc_name      : (localStorage.getItem("lang")==="en") ? "My Location" : "Η τοποθεσία μου",
      infoWindow_addr          : "",
      infoWindow_timetable_key : "",
      infoWindow_timetable_val : "",
      infoWindow_isOpen        : false,
      infoWindow_tel           : "",
      infoWindow_tel_key       : "",
      infoWindow_tel_val       : "",
      infoWindow_services      : "",
      infoWindow_show_WU_image : false,
      infoWindow_show_GC_image : false,
      infoWindow_lat           : lat1,
      infoWindow_lon           : lon1,
    });
    aProps.updateParentInitialLatLon(lat1,lon1);//sos//
    aProps.update_showingInfoWindow(true);
  }
}
//----------------------------------------------------------------------------------------------------
get_postcode_FromObj(obj){
  if(obj){
    if(localStorage.getItem("lang")==="en" && obj.post_code){ return obj.post_code; }
    if(localStorage.getItem("lang")!=="en" && obj.post_code){ return obj.post_code; }
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
get_localename_FromObj(obj){
  if(obj){
    if(localStorage.getItem("lang")==="en" && obj.locale_name_en){ return obj.locale_name_en; }
    if(localStorage.getItem("lang")!=="en" && obj.locale_name_el){ return obj.locale_name_el; }
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
get_isOpenNow_FromObj(obj){
  return wu_Utilities.timetableFiltering(obj,"openNow");
}
get_isOpenNow_FromObj_Color(obj){
  if(wu_Utilities.timetableFiltering(obj,"openNow")===true){return "green";}
  else                                                     {return "red";}
}
//----------------------------------------------------------------------------------------------------
get_phone_FromObj(obj){
  if(obj && obj.tel){
    let tel = obj.tel;
    if(tel.indexOf(",")>=0){tel = tel.substring(0, tel.indexOf(","));}
    if(tel.indexOf("-")>=0){tel = tel.substring(0, tel.indexOf("-"));}
    return tel;
  }
  return " - ";
}
//----------------------------------------------------------------------------------------------------
normalizeTimetableString(timetable){
  try{
    let timetableResult = "";
    let timetable_arr = timetable.split(",");
    for(let i=0; i<timetable_arr.length; ++i){
      timetableResult = timetableResult + timetable_arr[i];
    }
    return timetableResult;
  }catch(err){
    return timetable;
  }
}
//----------------------------------------------------------------------------------------------------
  onReady()                   { if(print_logs){console.log("callback onReady");}              }
  onDragend()                 { if(print_logs){console.log("callback onDragend");}            }
  onRecenter(mapProps, map)   { if(print_logs){console.log("callback onRecenter");}           }
  onBounds_changed()          { if(print_logs){console.log("callback onBounds_changed");}     }
  onCenter_changed()          { if(print_logs){console.log("callback onCenter_changed");}     }
  onDblclick()                { if(print_logs){console.log("callback onDblclick");}           }
  onDragstart()               { if(print_logs){console.log("callback onDragstart");}          }
  onHeading_change()          { if(print_logs){console.log("callback onHeading_change");}     }
  onIdle(props)               { if(print_logs){console.log("callback onIdle");}               }
  onMaptypeid_changed()       { if(print_logs){console.log("callback onMaptypeid_changed");}  }
//onMousemove()               { if(print_logs){console.log("callback onMousemove");}          }
//onMouseout()                { if(print_logs){console.log("callback onMouseout");}           }
//onMouseover()               { if(print_logs){console.log("callback onMouseover");}          }
  onProjection_changed()      { if(print_logs){console.log("callback onProjection_changed");} }
  onResize()                  { if(print_logs){console.log("callback onResize");}             }
  onRightclick()              { if(print_logs){console.log("callback onRightclick");}         }
  onTilesloaded(mapProps, map){
    let methName = "onTilesloaded"; if(print_logs){console.log("callback "+methName);}
    if(print_logs){console.log("callback "+methName+" map.getCenter().lat()= "+map.getCenter().lat());}
    if(print_logs){console.log("callback "+methName+" map.getCenter().lng()= "+map.getCenter().lng());}
    this.props.updateParentInitialLatLonZoom(map.getCenter().lat(),map.getCenter().lng(),this.props.initialZoom);
  }
  onTilt_changed()            { if(print_logs){console.log("callback onTilt_changed");}       }
  onZoom_changed()            { if(print_logs){console.log("callback onZoom_changed");}       }
  onZoomChanged()             { if(print_logs){console.log("callback onZoomChanged");}        }
//----------------------------------------------------------------------------------------------------
onMapClick(props){
  if(api.print_logs){console.log('onMapClick this.state.showingInfoWindow='+this.state.showingInfoWindow);}
  if (this.state.showingInfoWindow) {
    this.setState({
      showingInfoWindow : false,
      activeMarker      : null
    });
    this.props.update_showingInfoWindow(false);
  }
}
//----------------------------------------------------------------------------------------------------
onInfoWindowClose(){
  if(api.print_logs){console.log('onInfoWindowClose this.state.showingInfoWindow='+this.state.showingInfoWindow);}
  this.setState({
    showingInfoWindow : false,
    activeMarker      : null
  });
  this.props.update_showingInfoWindow(false);
}
//----------------------------------------------------------------------------------------------------
show_WU_image(obj){
  if(obj && obj.loc_Services){
    let WU_Index = obj.loc_Services.indexOf("WU");
    if(WU_Index>=0){ return true; }
  }
  return false;
}
//----------------------------------------------------------------------------------------------------
show_GC_image(obj){
  if(obj && obj.loc_Services){
    let BP_Index = obj.loc_Services.indexOf("BP");
    if(BP_Index>=0){ return true; }
  }
  return false;
}
//----------------------------------------------------------------------------------------------------
//--------------------------------------------------Utilities-----------------------------------------
//----------------------------------------------------------------------------------------------------
NSInforString = aKey => {
  if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
  else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
};
//----------------------------------------------------------------------------------------------------
}

export default GoogleApiWrapper({
  apiKey:("AIzaSyDKV9UZQGYyi_A71qdgwaoVtnb-aHcdfbw")  //WB
//apiKey: ("AIzaSyC9KxRzi9uCucyhMlEV35lulZ6cAwciJFk") //Veriah
})(GoogleMapsContainer)
